(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
(function () {
  var rootSelector = '#shopify-section-{{ section.id }}';

  function forceLoadDeferred(root) {
    var deferreds = root.querySelectorAll('deferred-media');
    deferreds.forEach(function(dm){
      try {
        if (typeof dm.loadContent === 'function') {
          dm.loadContent();
        } else {
          // Fallback: simulate the poster/button click to swap in real media
          var btn = dm.querySelector('button, .deferred-media__poster');
          if (btn) btn.dispatchEvent(new Event('click', {bubbles:true}));
        }
      } catch(e) {}
    });
  }

  function primeNativeVideos(root) {
    var vids = Array.prototype.slice.call(root.querySelectorAll('video'));
    vids.forEach(function(v){
      try {
        v.muted = true;
        v.autoplay = true;
        v.loop = true;
        v.setAttribute('playsinline','');
        // v.removeAttribute('controls'); // uncomment to hide controls
        var tries = 0;
        (function tryPlay(){
          tries++;
          var p = v.play && v.play();
          if (p && typeof p.then === 'function') {
            p.catch(function(){
              if (tries < 6) setTimeout(tryPlay, 350);
            });
          }
        })();
      } catch(e){}
    });
    return vids;
  }

  function tweakEmbeds(root) {
    var iframes = root.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, function(f){
      try {
        var u = new URL(f.src, window.location.origin);
        var host = u.hostname;
        if (/youtube|youtu\.be|youtube-nocookie/.test(host)) {
          u.searchParams.set('autoplay','1');
          u.searchParams.set('mute','1');
          u.searchParams.set('playsinline','1');
          u.searchParams.set('enablejsapi','1');
          if (f.src !== u.toString()) f.src = u.toString();
          f.setAttribute('allow','autoplay; encrypted-media; picture-in-picture');
          f.addEventListener('load', function(){
            try { f.contentWindow.postMessage(JSON.stringify({event:'command', func:'playVideo'}), '*'); } catch(e){}
          });
        } else if (/vimeo/.test(host)) {
          u.searchParams.set('autoplay','1');
          u.searchParams.set('muted','1');
          u.searchParams.set('background','1'); // hides controls; optional
          if (f.src !== u.toString()) f.src = u.toString();
          f.setAttribute('allow','autoplay; fullscreen; picture-in-picture');
          f.addEventListener('load', function(){
            try { f.contentWindow.postMessage(JSON.stringify({method:'play'}), '*'); } catch(e){}
          });
        }
      } catch(e){}
    });
  }

  function attempt(root) {
    if (!root) return;
    forceLoadDeferred(root);
    var vids = primeNativeVideos(root);
    tweakEmbeds(root);

    // If you only want the visible video to play, uncomment below:
    /*
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var v = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio > 0.25) {
          v.play && v.play().catch(function(){});
        } else {
          v.pause && v.pause();
        }
      });
    }, { threshold:[0,0.25,1] });
    vids.forEach(function(v){ io.observe(v); });
    */
  }

  function boot() {
    var root = document.querySelector(rootSelector);
    if (!root) return;

    // initial
    attempt(root);

    // re-run on DOM changes inside gallery (slides/variants)
    var mo = new MutationObserver(function(){ attempt(root); });
    mo.observe(root, { childList:true, subtree:true, attributes:true });

    // resume on tab focus
    document.addEventListener('visibilitychange', function(){
      if (!document.hidden) attempt(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor support (hot reload)
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.detail && e.detail.sectionId === '{{ section.id }}') {
      var node = document.getElementById('shopify-section-{{ section.id }}');
      attempt(node || document);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
